import { render, staticRenderFns } from "./imgCode.vue?vue&type=template&id=2481a03b&scoped=true"
import script from "./imgCode.vue?vue&type=script&lang=js"
export * from "./imgCode.vue?vue&type=script&lang=js"
import style0 from "./imgCode.vue?vue&type=style&index=0&id=2481a03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481a03b",
  null
  
)

export default component.exports